import React, { useEffect, useRef } from 'react';
import Link from 'components/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  // PAID,
  // TOI_PLUS,
  // TOI_SUBS_FETCH_PLANS_WEB,
  // TOI_SUBS_FETCH_PLANS_MWEB,
  // TOI_SUBS_PLAN_TRANSLATION_WEB,
  // TOI_SUBS_PLAN_TRANSLATION_MWEB,
  // YEAR_IN_DAYS,
  PRC_FOR_SUBSCRIBED,
} from 'constants/index';
import Cookie from 'utils/cookies';
import {
  // checkNewUser,
  setPayloadInfo,
  getUserAccessPayload,
  // getGeoCountry,
  generateOneLinkURL,
  getEncTicket,
  storeRenewNudgeCloseTime,
} from 'utils/primeUtil';
// import makeRequest from 'utils/makeRequest';
import {
  // handlePlanClick,
  loadPaymentSdk,
} from 'components/ToiSubscription/utils/payment';
import { getGa4PageViewSet, collectEventfireGa4 } from 'utils/common';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
  sendDataToGAWithGRX,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import throttle from 'lodash.throttle';
import withNudgeLogic from './hoc/WithNudgeLogic';

import s from './toipNudges.scss';

const HomePageNudge = props => {
  const {
    nudgeText,
    isWapView,
    viewType,
    userData,
    isToiPlusAllowReadOnly,
    inGracePeriod,
    ispreExpired,
    replaceDate,
    preExpireHeading,
    // geo,
    // daysRemaining,
    getLoadingStatus,
    userPrcData,
    getNudgeHeight,
    graceDate,
  } = props;

  useEffect(() => {
    loadPaymentSdk();
    setTimeout(() => {
      if (typeof getLoadingStatus === 'function') {
        getLoadingStatus('DONE');
      }
    }, 100);
  }, []);
  // const getSubscriptionPlan = async geoCountry => {
  //   const planUrl = `${
  //     isWapView ? TOI_SUBS_FETCH_PLANS_MWEB : TOI_SUBS_FETCH_PLANS_WEB
  //   }&cc=${geoCountry}&listView=true`;
  //   const subscriptionData = await makeRequest.get(planUrl);
  //   let subscriptionRes;
  //   let selectedPlan;
  //   if (subscriptionData?.data?.data) {
  //     subscriptionRes = subscriptionData?.data?.data;
  //   }
  //   if (
  //     subscriptionRes &&
  //     Array.isArray(subscriptionRes.plans) &&
  //     subscriptionRes.plans.length > 0
  //   ) {
  //     for (let i = 0; i < subscriptionRes.plans.length; i += 1) {
  //       if (
  //         subscriptionRes.plans[i] &&
  //         subscriptionRes.plans[i].durationInDays &&
  //         subscriptionRes.plans[i].durationInDays === YEAR_IN_DAYS &&
  //         subscriptionRes.plans[i].planType &&
  //         subscriptionRes.plans[i].planType === PAID &&
  //         subscriptionRes.plans[i].subscription &&
  //         subscriptionRes.plans[i].subscription.accessType &&
  //         subscriptionRes.plans[i].subscription.accessType === TOI_PLUS
  //       ) {
  //         selectedPlan = subscriptionRes.plans[i].planId;
  //       }
  //     }
  //   }
  //   return selectedPlan;
  // };

  const isLoggedIn =
    userData && userData.isLoggedIn ? userData.isLoggedIn : undefined;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
  const getAnalyticsMetaData = () => {
    let nudgeCategory = 'landingpage_inline_nudge';
    if (inGracePeriod) {
      nudgeCategory = `Grace_${
        viewType === 'toiplushomepage' ? 'Landingpage' : 'Listingpage'
      }_Inline_Nudge`;
    } else if (ispreExpired) {
      nudgeCategory = `EarlyRenew_${
        viewType === 'toiplushomepage' ? 'Landingpage' : 'Listingpage'
      }_Inline_Nudge`;
    } else {
      nudgeCategory = `${
        viewType === 'toiplushomepage' ? 'Landingpage' : 'Listingpage'
      }_inline_nudge`;
    }

    return {
      acqSubSource: nudgeCategory,
      item_category3: nudgeCategory,
    };
  };
  const redirection = () => {
    if (isLoggedIn || Cookie.get('ssoid') || Cookie.get('ssoId')) {
      getEncTicket(isWapView).then(data => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData(
            {
              ...nudgeText,
              acqSubSource: getAnalyticsMetaData().acqSubSource,
            },
            data,
          ),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData({
          ...nudgeText,
          acqSubSource:
            viewType === 'toiplushomepage'
              ? 'landingpage_inline_nudge'
              : 'listingpage_inline_nudge',
        }),
      );
    }
  };

  const fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: 'select_item',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2:
        viewType === 'toiplushomepage' ? 'TOIPlus_Landing' : 'TOIPlus_Listing',
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
      location_id: obj?.location_id ? obj?.location_id : 'N/A',
    });
  };

  const fireGAAndJustPayRedirection = async (e, pageType) => {
    e.preventDefault();
    setPayloadInfo('prime-login_blocker|CTA', 'NON_STORY');
    let category = '';
    switch (pageType) {
      case 'toiplushomepage':
        if (isWapView) {
          category = 'WAP-primehome';
        } else {
          category = 'WEB-Prime-Home';
        }
        break;
      default:
        if (isWapView) {
          category = 'WAP-primelist';
        } else {
          category = 'WEB-Prime-HPListing';
        }
    }
    analyticsWrapper(
      'ga',
      'send',
      'event',
      category,
      'prime-login_blocker|CTA',
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
    );

    const grxParams = [
      'paywall',
      {
        client_source: 'cdp',
        event_nature: 'click',
        event_category: 'subscription',
        cta_text: nudgeText?.ctaTxt || nudgeText?.secCtaTxt || 'Subscribe Now',
        // event_section: 'homepage_nudge',
        // event_sub_section: '',
        // landing_l1: 'plan_page',
        // landing_l2: '',
        // landing_l3: '',
        // landing_page_template: 'toiplus_homepage',
        // landing_url: redirectToNewPlanpage(
        //   newPlanpageMetaData(nudgeText)),
        // position: 2,
        unique_subscription_id: `${Cookie.get('_grx')}_${new Date().getTime()}`,
      },
    ];
    let cdpInfo = {};
    if (
      typeof window.grx !== 'undefined' &&
      typeof window?.grx_module?.hitPaywallEventReact === 'function'
    ) {
      window.grx_module.hitPaywallEventReact(...grxParams);
      cdpInfo = window.grx_module.getCdpInfo() || {};
    } else {
      window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
        eventName: grxParams[0],
        payload: grxParams[1],
      });
    }
    if (window !== 'undefined') {
      if (e.target) {
        const cdpParamsObj = grxParams[1] || {};
        const dataToBepassed = {
          accessiblefeatures: userPrcData?.accessibleFeatures,
          source: userPrcData?.source,
          accessType: userPrcData?.accessType,
          objUserData: {
            email:
              typeof userData.getEmail !== 'undefined'
                ? userData.getEmail()
                : '',
            fname:
              typeof userData.getFirstName !== 'undefined'
                ? userData.getFirstName()
                : '',
          },
          analytics_cdp: {
            eventName: grxParams[0],
            ...cdpParamsObj,
            ...cdpInfo,
          },
          ga4Items: fireGA4({
            item_category4: e.target.innerText || '',
            item_category3: getAnalyticsMetaData().item_category3,
          }),
        };
        sendDataToGAWithGRX(dataToBepassed)
          .then(redirection)
          .catch(redirection);
      }
    }
  };

  const openDeeplinkUrl = e => {
    e.preventDefault();
    const oneLinkUrl = generateOneLinkURL('Home');
    analyticsWrapper(
      'ga',
      'send',
      'event',
      'WAP-primehome',
      'prime-login_blocker|CTA',
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
    );
    if (oneLinkUrl) {
      window.location.href = oneLinkUrl;
    }
  };

  const benefits = nudgeText?.benefits?.length > 0 && nudgeText.benefits;

  const nudgeRef = useRef(null);

  const closeBtnHandler = () => {
    storeRenewNudgeCloseTime();
    getNudgeHeight(0);
  };

  const heightCheck = () => {
    setTimeout(() => {
      const eleHeight = nudgeRef.current?.clientHeight;
      if (typeof getNudgeHeight === 'function') {
        getNudgeHeight(eleHeight);
      }
    }, 1000);
  };

  const windowResize = () => throttle(heightCheck, 100);

  useEffect(
    () => {
      heightCheck();
    },
    [nudgeText, inGracePeriod, ispreExpired],
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', windowResize());
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', windowResize());
      }
    };
  }, []);

  if (!nudgeText || isToiPlusAllowReadOnly) {
    return null;
  }

  if (
    isWapView &&
    !isToiPlusAllowReadOnly &&
    (inGracePeriod || ispreExpired) &&
    nudgeText
  ) {
    return (
      <div className={s.user_expiry_info} ref={nudgeRef}>
        <img
          src={`https://static.toiimg.com/photo/${nudgeText.imageMsid}.cms`}
          alt="toip home page nudge"
        />
        <div className={s.inner}>
          {ispreExpired &&
            !inGracePeriod && (
              <>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: preExpireHeading,
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: nudgeText.h2,
                  }}
                />
              </>
            )}
          {inGracePeriod &&
            !ispreExpired && (
              <>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: replaceDate,
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: nudgeText?.h2?.replace(
                      '<gracedate>',
                      `${graceDate}`,
                    ),
                  }}
                />
              </>
            )}
          <div className={s.button_container}>
            <button
              className={`${s.btn} ${s.red}`}
              onClick={e =>
                nudgeText?.ctaTxt === 'DOWNLOAD NOW'
                  ? openDeeplinkUrl(e)
                  : fireGAAndJustPayRedirection(e, viewType)
              }
            >
              {nudgeText.ctaTxt}
            </button>
            {ispreExpired && (
              <button className={`${s.btn}`} onClick={closeBtnHandler}>
                {nudgeText.secCtaTxt}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {!isToiPlusAllowReadOnly && (
        <div id="topNudgeID" className={s.topNudge} ref={nudgeRef}>
          {!isWapView && (
            <div>
              <a className={s.toipLogo} aria-label="toi-plus">
                {' '}
              </a>
            </div>
          )}
          <div>
            {!ispreExpired &&
              !inGracePeriod &&
              getUserAccessPayload()?.planStatus !== PRC_FOR_SUBSCRIBED && (
                <div
                  id="headingID"
                  className={s.heading}
                  dangerouslySetInnerHTML={{
                    __html: nudgeText?.h1,
                  }}
                />
              )}
            {ispreExpired &&
              !inGracePeriod && (
                <div
                  className={s.heading}
                  dangerouslySetInnerHTML={{
                    __html: preExpireHeading,
                  }}
                />
              )}
            {inGracePeriod &&
              !ispreExpired && (
                <div
                  className={s.heading}
                  dangerouslySetInnerHTML={{
                    __html: replaceDate,
                  }}
                />
              )}

            {!isWapView &&
              benefits && (
                <div className={s.benefits}>
                  {benefits.map((benefit, idx) => <p key={idx}>{benefit}</p>)}
                </div>
              )}
          </div>
          <div className={s.subscribeBtn1}>
            <Link
              className={s.btnText}
              onClick={e =>
                nudgeText?.ctaTxt === 'DOWNLOAD NOW'
                  ? openDeeplinkUrl(e)
                  : fireGAAndJustPayRedirection(e, viewType)
              }
            >
              {nudgeText?.ctaTxt || nudgeText?.secCtaTxt || 'Subscribe Now'}
            </Link>
          </div>
          {!isWapView &&
            ispreExpired && (
              <span className={s.cross} onClick={closeBtnHandler} />
            )}
        </div>
      )}
    </>
  );
};

export default React.memo(withNudgeLogic(HomePageNudge, 'homepage'));
